import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth.service';
import { LOCAL_STORAGE_KEYS } from '../../shared/constants/storage-keys';

@Component({
    selector: 'tdms-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    standalone: false
})
export class CallbackComponent implements OnInit {

  errorMsg: any;
  tokenRef: string | null = null;
  referrerURL: string | null = null;

  constructor(private auth: AuthService, private route: ActivatedRoute, private router: Router, private http: HttpClient) { }

  async ngOnInit() {
      // The backend redirects to /callback?tokenRef=...&referrer=...
      this.tokenRef = this.route.snapshot.queryParamMap.get('tokenRef');
      this.referrerURL = this.route.snapshot.queryParamMap.get('referrer');
      const challengeKey = sessionStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_CODE_VERIFIER);

      if (!this.tokenRef) {
        console.error('Callback missing required token:', this.tokenRef);
        this.errorHandler(new Error('Missing tokenRef'));
        return;
      }

      const referrer = this.referrerURL || '/analysis/dashboard';
      const tokenURL = `/api/us/auth/token?tokenRef=${encodeURIComponent(this.tokenRef)}&referrer=${encodeURIComponent(referrer)}`;
      this.http.post<{ access_token: string }>(tokenURL, { challengeKey }).subscribe({
        next: (res) => {
          sessionStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_CODE_VERIFIER);
          this.auth.setToken(res.access_token);
          // Fetch user info/access checks and navigate to the resolved dashboard route
          this.auth.handleAuthCallback(referrer);
        },
        error: (err) => {
          sessionStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_CODE_VERIFIER);
          this.errorHandler(err);
        }
      });
  }

  errorHandler(err: any) {
    console.error('Callback error:', err);
    this.auth.logout();
  }

}
